/**
 * /search page — AJAX-intercept new-search-from-search-page (Phase 8d)
 *
 * When user is already on /search and submits a new search from the
 * header search bar, hijack the form submit and use FacetFiltersForm's
 * existing renderPage() (fetch → partial DOM swap of #ProductGridContainer)
 * instead of allowing full-page navigation.
 *
 * Effect: tabs / facets / grid swap smoothly like a filter apply does,
 * scroll position is preserved, the header truly stays put rather than
 * being re-parsed. Feels much less "flicker-y" than a browser reload.
 *
 * Fallback: if FacetFiltersForm isn't loaded yet or renderPage throws,
 * we let the browser handle the submit natively (no interference).
 *
 * URL: renderPage's updateURLHash=true calls history.pushState so
 * back/forward + refresh still work correctly.
 */
(function () {
  'use strict';

  function isOnSearchPage() {
    // /search, /search/, but not /search-something-else
    return /^\/search\/?$/.test(window.location.pathname);
  }

  function canAjax() {
    return !!(window.FacetFiltersForm && typeof FacetFiltersForm.renderPage === 'function');
  }

  function onSubmit(e) {
    if (!canAjax()) return; // Let browser navigate.
    var form = e.currentTarget;
    var input = form.querySelector('input[name="q"]');
    if (!input) return;
    var q = (input.value || '').trim();
    if (!q) return;

    // Build search params. Preserve any select-based filter (search by
    // product type/vendor) that lives inside the form.
    var params = new URLSearchParams();
    params.set('q', q);
    // Shopify's prefix helper — matches what the theme sends on facet
    // submits. Kept optional; header form doesn't include it.
    form.querySelectorAll('select[name], input[type="hidden"][name]').forEach(function (el) {
      if (el.name === 'q') return;
      if (el.value) params.set(el.name, el.value);
    });

    e.preventDefault();
    try {
      FacetFiltersForm.renderPage(params.toString(), null, true);
      // Close the predictive-search dropdown — normally it closes on
      // navigation, but our AJAX intercept skips that. Also blur the
      // input so keyboard focus doesn't re-open it via focus handler.
      var searchFormEl = form.closest('search-form');
      if (searchFormEl && typeof searchFormEl.close === 'function') {
        searchFormEl.close();
      } else {
        document.body.classList.remove('open-search');
      }
      if (input && typeof input.blur === 'function') input.blur();
    } catch (err) {
      window.location.href = '/search?' + params.toString();
    }
  }

  function bindHeaderForms() {
    // Header search forms: role=search, action ending /search. Excludes
    // the facet filter form (which has id FacetFiltersForm / Mobile).
    document.querySelectorAll('form[role="search"][action$="/search"]').forEach(function (form) {
      if (form.__aroHijacked) return;
      // Skip if it's inside #ProductGridContainer (the facet form).
      if (form.closest('#ProductGridContainer')) return;
      form.__aroHijacked = true;
      form.addEventListener('submit', onSubmit);
    });
  }

  function init() {
    if (!isOnSearchPage()) return;
    bindHeaderForms();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
